import "./YealinkProduct.module.css";
import Header from "@/reusable_sections/Header";
import HeroSolucionesYealinkTeams from "./sections/HeroSolucionesYealinkTeams";
import BeneficiosClaveYealink from "./sections/BeneficiosClaveYealink";
import CategoriasDeProductos from "./sections/CategoriasDeProductos";
import TechnicalSpecificationsHighlights from "./sections/TechnicalSpecificationsHighlights";
import FormularioDeContactoSolicitarDemo from "./sections/FormularioDeContactoSolicitarDemo";
import Videosolutionyealink from "./sections/Videosolutionyealink";
import Footer from "@/reusable_sections/Footer";
export default function YealinkProductPage() {
  return <div>
      <Header />
      <HeroSolucionesYealinkTeams />
      <BeneficiosClaveYealink />
      <Videosolutionyealink />
      <CategoriasDeProductos />
      <TechnicalSpecificationsHighlights />
      <FormularioDeContactoSolicitarDemo />
      <Footer />
    </div>;
}